<template>
<div>
	<div id="print-layout" style="background-color: #ffffff;">
    <slot />
	</div>
</div>
</template>
<script>
// import navbar from '@/components/layout/Navbar'
export default {
	name: 'Print',
	components: {
		// navbar
	},
	mounted () {
		const plugin = document.createElement('script')
		plugin.setAttribute(
			'src',
			'https://kit.fontawesome.com/c1b864fb23.js'
		)
		document.head.appendChild(plugin)
	},
	computed: {
	}
}

</script>
<style>
#content-body {
  background-image: none;
  background-color: #ffffff;
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/Print.vue